import { safeScrollTo } from "@faire/retailer-visitor-shared/lib/safeScrollTo";
import { getDocumentOrThrow } from "@faire/web--source/common/globals/getDocument";
/**
 * Scrolls to a section smoothly
 *
 * @param sectionId The ID of the section to scroll to.
 * @param headerHeight The height of the header if you want to include in the offset calculation; specially useful in mobile where the header hides on scrolling
 */ export var goToSmoothly = function(sectionId) {
    var headerHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var targetElement = getDocumentOrThrow().getElementById(sectionId);
    var targetPosition = targetElement ? targetElement.offsetTop + headerHeight : 0;
    safeScrollTo({
        left: 0,
        top: targetPosition,
        behavior: "smooth"
    });
};
